export default "__VITE_ASSET__Cb$npKAp__"